// API configuration with environment variable support
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default {
  baseUrl: API_URL,
  endpoints: {
    updates: '/api/updates',
    login: '/api/login',
    logout: '/api/logout',
    protected: '/api/protected',
    faqs: '/api/faqs',
    faqCategories: '/api/faqs/categories'
  }
}; 